import moment from 'moment';
import { clone } from 'ramda';


export const lengthGt = (data, length, desc) => {
  return (data.trim()).length > 4 ? true : desc + ' must be longer than 4 characters';
};

// TODO this could be made nicer?
export const lengthInRange = (data, r, desc) => {
  const str = data.trim(),
        err = desc + ' must be ' + r[0] + ' to ' + r[1] + ' characters';

  return str.length >= r[0] && str.length <= r[1] ? true : err;
};

export const notEmpty = (data, desc) => {
  return !!data ? true: desc + ' missing';
};

export const emptyOrValidDate = (dateStr, desc) => {
  const m = moment(dateStr);

  return dateStr === '' || m.isValid() ? true : 'Invalid ' + desc + ':' + dateStr;
};

export const datesInOrder = (d) => {
  if (moment(d[1]).isSameOrAfter(moment(d[0]))) {
    return true;
  } else {
    return 'Invalid date range:' + d[0] + '-' + d[1];
  }
};

export const intInRange = (data, r, desc) => {
  const i = parseInt(data, 10),
        err = desc + ' must be an integer in the range of ' + r[0] + '-' + r[1];

  return Number.isInteger(i) && i >= r[0] && i <= r[1] ? true : err;
};

export const validUrl = (data, desc) => {
  if (data.substr(0, 8) === 'https://' || data.substr(0, 7) === 'http://') {
    return true;
  }

  return 'Invalid ' + desc;
};

export const truthy = (data, bool, desc) => {
  return data ? true : desc;
};

export const report = (checks) => {
  const errors = checks.filter(c => c !== true);
  
  return {
    enabled: !errors.length,
    errors: errors
  };
};


export const validUser = (userAttributes) => {
  const user = clone(userAttributes) || {};
  
  if (!user.given_name || !user.family_name) {
    return false;
  } else if (!user['custom:phone_number']) {
    return false;
  } else if (!user['custom:occupation'] || !user['custom:occupation_details']) {
    return false;
  } else if (!user['custom:year_of_birth'] || !user['custom:country_of_residence']) {
    return false;
  } else if (user['custom:country_of_residence'] === 'ee' && !user['custom:county_of_residence']) {
    return false;
  }

  return true;
};



// WEBPACK FOOTER //
// ./src/common/utils/inputValidator.js